



























// 3rd party lib
import {
    mapGetters,
} from 'vuex';

// Components
import partnerLogo from '@webapp/components/partner-logo/partner-logo.vue';
import tokenParticipationAmount from '@webapp/modules/rewards/components/fanshop/token-participation-amount.vue';

// Utils
import {
    format,
} from '@shared/utils/dates.js';

export default {
    name: 'leaderboard-header',
    components: {
        partnerLogo,
        tokenParticipationAmount,
    },
    props: {
        leaderboardData: {
            type: Object,
            default: null,
        },
        showParticipationAmount: {
            type: Boolean,
            default: false,
        },
        isSearchEnabled: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        logoUrl: '',
    }),
    computed: {
        ...mapGetters('partners', ['partnerById']),

        ...mapGetters('wallet', ['decentralizedLedgerByToken']),

        ...mapGetters('voteTokens', ['getVoteTokenByCurrencyId']),

        availabilityDate() {
            if (!this.leaderboardData.startAt || !this.leaderboardData.endAt) {
                return;
            }

            return format(this.leaderboardData.startAt, 'dateShort') + ' - ' + format(this.leaderboardData.endAt, 'dateShort');
        },

        partnerId() {
            return this.leaderboardData?.partner?.id ?? null;
        },

        partnerData() {
            return this.partnerById(this.partnerId);
        },
    },
};
